module.exports = __webpack_public_path__ + "img/Rectangle 627.a86fa827.png";